import {
  SHIFT_LIST_SEARCH, SHIFT_LIST_SEARCH_FAILURE, SHIFT_LIST_SEARCH_SUCCESS,
  SHIFT_DETAIL, SHIFT_DETAIL_FAILURE, SHIFT_DETAIL_SUCCESS
} from './mutation-types'

export default {
  state: {
    shift_dates: [],
    shifts: [],
    shiftDetailHayaho: [],
    shiftDetailHayaka: [],
    shiftDetailNakaho: [],
    shiftDetailOsoho: [],
    shiftDetailOsoka: [],
    shiftDetailSonota: [],
    shiftDetailShopConfiguration: null,
    shiftDetailMine: null,
    shiftDetailHoliday: false,
    shiftDetailWeek: null
  },
  getters: {
    shift_dates: state => {
      return state.shift_dates
    },
    shifts: state => {
      return state.shifts
    },
    shiftDetailHayaho: state => {
      return state.shiftDetailHayaho
    },
    shiftDetailHayaka: state => {
      return state.shiftDetailHayaka
    },
    shiftDetailNakaho: state => {
      return state.shiftDetailNakaho
    },
    shiftDetailOsoho: state => {
      return state.shiftDetailOsoho
    },
    shiftDetailOsoka: state => {
      return state.shiftDetailOsoka
    },
    shiftDetailSonota: state => {
      return state.shiftDetailSonota
    },
    shiftDetailShopConfiguration: state => {
      return state.shiftDetailShopConfiguration
    },
    shiftDetailMine: state => {
      return state.shiftDetailMine
    },
    shiftDetailHoliday: state => {
      return state.shiftDetailHoliday
    },
    shiftDetailWeek: state => {
      return state.shiftDetailWeek
    }
  },
  actions: {
    [SHIFT_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/asovi/shifts'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHIFT_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(SHIFT_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SHIFT_DETAIL] ({dispatch, state, commit}, params = null) {
      var data = {}
      data = params.data
      dispatch('apiGet', {url: '/asovi/shifts/' + params.data.target_date, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHIFT_DETAIL_FAILURE, res.data)
          } else {
            commit(SHIFT_DETAIL_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [SHIFT_LIST_SEARCH_FAILURE] (state, params) {
      console.log('SHIFT_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [SHIFT_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('SHIFT_LIST_SEARCH_SUCCESS')
      state.shift_dates = params.data.shift_dates
      state.shifts = params.data.shifts
      if (params.callback) {
        params.callback()
      }
    },
    [SHIFT_DETAIL_FAILURE] (state, params) {
      console.log('SHIFT_DETAIL_FAILURE')
    },
    [SHIFT_DETAIL_SUCCESS] (state, params) {
      console.log('SHIFT_DETAIL_SUCCESS')
      var data = params.data
      state.shiftDetailHayaho = data.haya_ho
      state.shiftDetailHayaka = data.haya_ka
      state.shiftDetailNakaho = data.naka_ho
      state.shiftDetailOsoho = data.oso_ho
      state.shiftDetailOsoka = data.oso_ka
      state.shiftDetailSonota = data.sono_ta
      state.shiftDetailShopConfiguration = data.shift_shop_configuration
      state.shiftDetailHoliday = data.is_holiday
      state.shiftDetailWeek = data.week
      state.shiftDetailMine = data.mine_shift
      if (params.callback) {
        params.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shift.js